
import { BillingAddress } from "../../models/billing-address";
import { CompanyService } from "../../services/company-service";
import AppCountryCodeAutocomplete from "@/components/CountryCodeAutocomplete.vue";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { HttpError } from "@/utils/services/http-error";
import { isStringEmail } from "@/utils/strings";

export default FormLike.extend({
	data(){
		return {
			focused: {
				firstName: false,
				lastName: false,
				address: false,
				postal: false,
				place: false,
				country: false,
				tel: false,
				email: false,
			},
			errorFields: {
				firstName: false,
				lastName: false,
				address: false,
				postal: false,
				place: false,
				country: false,
				tel: false,
				email: false,
			},
			vatNumberDisabled: false,
			address: new BillingAddress(),
		};
	},
	props: {
		cancelButton: Boolean
	},
	watch: {
		address: {
			immediate: true,
			deep: true,
			handler(){
				this.validate();
			}
		},
	},
	methods: {
		async submit(){
			if (!this.isValid) return;
			this.address = await CompanyService.setBillingAddress(this.address);
			this.vatNumberDisabled = true;
			this.$wf.notify(this.$ct("billing-address-saved"), "success", 3000, "check");
			this.$emit("update", this.address);
		},
		emailValidator(): boolean {
			this.errorFields.email = false;
			if (!isStringEmail(this.address.email)) {
				if (this.focused.email) {
					this.errorFields.email = true;
				}
				return false;
			}
			return true;
		},
		phoneValidator(): boolean {
			let re = /^[0-9 .\(\)\/\+]+$/;
			this.errorFields.tel = false;
			if (!re.test(this.address.tel.toLowerCase())) {
				if (this.focused.tel) {
					this.errorFields.tel = true;
				}
				return false;
			}
			return true;
		},
		shouldShowRequiredError(field:string):boolean{
			return (this.focused as any)[field] && ((this.errorFields as any)[field] || !(this.address as any)[field]);
		}
	},
	async created(){
		try{
			this.address = await CompanyService.getBillingAddress();
			if (this.address.vatNumber != "") {
				this.vatNumberDisabled = true;
			}
		}catch(err){
			let e = err as HttpError;
			if (e.key == "ID_IS_NOT_VALID") {
				e.dontShow = true;
			}
		}
		this.validators = [this.emailValidator];
	},
	i18nEx: {
		componentPrefix: "components.account"
	},
	components: {
		AppCountryCodeAutocomplete
	}
});
